import React, { Component } from 'react';
import { withRouter } from '../withRouter.js';
import apiMunicipios from '../services/apiMunicipios.js';

import theme from './themes/Theme';
import { ThemeProvider } from '@mui/material';

import Button from '@mui/material/Button';
import NavigateNext from '@mui/icons-material/NavigateNext';
import NavigateBefore from '@mui/icons-material/NavigateBefore';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

import Header from '../components/Header.js';
import FooterHome from '../components/FooterHome.js';

let anotherItems = ['Administrativo', 'Defesa da cidadania', 'Direitos humanos', 'Infância e Juventude', 'Patrimônio cultural',
  'Serviços públicos', 'Notícias'];

class Search extends Component {

  state = {
    user_id: '',
    login: '',
    option: '',
    selected_city: 'rios',
    secretary: '',
    secretary_id: '',

    subcategory: '',
    subcategory_select: 'select',
    subcategories: [],
    parents: [],

    zoom: 12,
    mobilezoom: 11,
    latitude: '',
    longitude: '',
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},

    places: [],

    cpf_cnpj: '',
    name: '',
    email: '',
    street: '',
    number: '',
    district: '',
    city: '',
    state: '',

    new_lat: '',
    new_lng: '',

    expanded: false,
    openDialog: false,

    renderTable: false,

    row: true,

    data: [],
    children: [],

    open: false,
    open_error: false,
    msg: '',

    iframeUrl: '',
  }

  async componentDidMount() {
    if (this.props.location.state) {
      await this.setState({ login: this.props.location.state.fields.login });
      await this.setState({ option: this.props.location.state.fields.option });
      await this.setState({ selected_city: this.props.location.state.fields.selected_city });
      await this.setState({ name: this.props.location.state.fields.name.split('"').join('') });
      await this.setState({ secretary: this.props.location.state.fields.secretary.split('"').join('') });
      await this.setState({ secretary_id: this.props.location.state.fields.secretary_id });
      await this.setState({ user_id: this.props.location.state.fields.user_id });
    } else {
      const idx = document.URL.indexOf('?');

      var params = [];
      if (idx !== -1) {
        var pairs = document.URL.substring(idx + 1, document.URL.length).split('&');
        //alert(pairs);
        for (var i = 0; i < pairs.length; i++) {
          let nameVal = pairs[i].split(',');
          nameVal = pairs[i].replace('login=', '');
          nameVal = nameVal.replace('option=', '');
          nameVal = nameVal.replace('selected_city=', '');
          nameVal = nameVal.replace('name=', '');
          nameVal = nameVal.replace('secretary=', '');
          nameVal = nameVal.replace('secretary_id=', '');
          nameVal = nameVal.replace('user_id=', '');
          params.push(nameVal);
        }
      }

      await this.setState({ login: decodeURI(params[0]) });
      await this.setState({ option: decodeURI(params[1]) });
      await this.setState({ selected_city: decodeURI(params[2]) });
      await this.setState({ name: decodeURI(params[3]) });
      await this.setState({ secretary: decodeURI(params[4]) });
      await this.setState({ secretary_id: decodeURI(params[5]) });
      await this.setState({ user_id: decodeURI(params[6]) });
    }

    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.setState({ row: false });
    } else {
      this.setState({ row: true });
    }
  }

  handleChangePanel = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  }

  render() {

    return (

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        margin: -10,
      }}
      >

        <ThemeProvider theme={theme}>

          <Header
            history={this.props.history}
            login={this.state.login}
            option={this.state.option}
            selected_city={this.state.selected_city}
            name={this.state.name}
            secretary={this.state.secretary}
            secretary_id={this.state.secretary_id}
            user_id={this.state.user_id}
            {...this.props}
          />

          <Box sx={{
            backgroundColor: '#E5E6F0',
          }}
          >

            {this.state.row ? (
              <div style={styles.directionRow}>
                <Box
                  sx={{
                    width: '30%',
                    height: window.innerHeight,
                    backgroundColor: '#E5E6F0',
                  }}
                >
                  {anotherItems.map((item) =>
                    <div>
                      {item === 'Notícias' ? (
                        <div>
                          {this.state.selected_city === 'rios' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=tr%C3%AAs%20rios&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'paulo' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=paulo%20de%20frontin&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'saquarema' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=saquarema&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'queimados' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=queimados&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'nova' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=nova%20iguaçu&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'itaocara' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=itaocara&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'campos' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=campos&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'rj' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=rio%20de%20janeiro&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=cabo%20frio&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          )}
                        </div>
                      ) : (
                        <Accordion
                          expanded={this.state.expanded === `panel${item}`}
                          onChange={this.handleChangePanel(`panel${item}`)}
                          style={styles.button}
                        //onClick={() => readFile()}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${item}a-content`}
                            id={`panel${item}a-header`}
                          >
                            <Typography>
                              {item}
                            </Typography>
                          </AccordionSummary>

                          <AccordionDetails>

                            <div style={styles.directionRow}>
                              <TextField
                                style={{ margin: 10 }}
                                id={`keyword${item}`}
                                name={`keyword${item}`}
                                label="Buscar por palavra chave"
                                variant="outlined"
                              />

                              <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 12, marginLeft: 10, height: 50, textTransform: 'none' }}
                                onClick={() => {
                                  if (this.state.selected_city === 'paulo') {
                                    this.setState({ iframeUrl: `${apiMunicipios}/readfilepaulo/${item},${document.getElementById('keyword' + item).value}` });
                                  } else {
                                    if (this.state.selected_city === 'cabo') {
                                      this.setState({ iframeUrl: `${apiMunicipios}/readfilecabo/${item},${document.getElementById('keyword' + item).value}` });
                                    } else {
                                      if (this.state.selected_city === 'saquarema') {
                                        this.setState({ iframeUrl: `${apiMunicipios}/readfilesaquarema/${item},${document.getElementById('keyword' + item).value}` });
                                      } else {
                                        if (this.state.selected_city === 'queimados') {
                                          this.setState({ iframeUrl: `${apiMunicipios}/readfilequeimados/${item},${document.getElementById('keyword' + item).value}` });
                                        } else {
                                          if (this.state.selected_city === 'nova') {
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilenova/${item},${document.getElementById('keyword' + item).value}` });
                                          } else {
                                            if (this.state.selected_city === 'itaocara') {
                                              this.setState({ iframeUrl: `${apiMunicipios}/readfileitaocara/${item},${document.getElementById('keyword' + item).value}` });
                                            } else {
                                              if (this.state.selected_city === 'campos') {
                                                this.setState({ iframeUrl: `${apiMunicipios}/readfilecampos/${item},${document.getElementById('keyword' + item).value}` });
                                              } else {
                                                if (this.state.selected_city === 'rj') {
                                                  this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item},${document.getElementById('keyword' + item).value}` });
                                                } else {
                                                  this.setState({ iframeUrl: `${apiMunicipios}/readfile/${item},${document.getElementById('keyword' + item).value}` });
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }}
                              >
                                Buscar
                              </Button>
                            </div>

                          </AccordionDetails>

                        </Accordion>
                      )}
                    </div>
                  )}
                  <TextField
                    style={{ margin: 20 }}
                    id="pref"
                    name="pref"
                    label="Buscar por palavra chave"
                    variant="outlined"
                  />

                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: 30, marginLeft: 20, textTransform: 'none', }}
                    onClick={() => {
                      if (this.state.selected_city === 'paulo') {
                        this.setState({ iframeUrl: `${apiMunicipios}/readfilepaulo/${document.getElementById('pref').value}` });
                      } else {
                        if (this.state.selected_city === 'cabo') {
                          this.setState({ iframeUrl: `${apiMunicipios}/readfilecabo/${document.getElementById('pref').value}` });
                        } else {
                          if (this.state.selected_city === 'saquarema') {
                            this.setState({ iframeUrl: `${apiMunicipios}/readfilesaquarema/${document.getElementById('pref').value}` });
                          } else {
                            if (this.state.selected_city === 'queimados') {
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilequeimados/${document.getElementById('pref').value}` });
                            } else {
                              if (this.state.selected_city === 'nova') {
                                this.setState({ iframeUrl: `${apiMunicipios}/readfilenova/${document.getElementById('pref').value}` });
                              } else {
                                if (this.state.selected_city === 'itaocara') {
                                  this.setState({ iframeUrl: `${apiMunicipios}/readfileitaocara/${document.getElementById('pref').value}` });
                                } else {
                                  if (this.state.selected_city === 'campos') {
                                    this.setState({ iframeUrl: `${apiMunicipios}/readfilecampos/${document.getElementById('pref').value}` });
                                  } else {
                                    if (this.state.selected_city === 'rj') {
                                      this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${document.getElementById('pref').value}` });
                                    } else {
                                      this.setState({ iframeUrl: `${apiMunicipios}/readfile/${document.getElementById('pref').value}` });
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }}
                  >
                    Buscar
                  </Button>
                </Box>

                <Box
                  sx={{
                    width: '60%',
                    height: window.innerHeight,
                    backgroundColor: '#bfcadb',
                    marginBottom: 10
                  }}
                >
                  {this.state.iframeUrl ? (
                    <iframe src={this.state.iframeUrl} title="Processos" style={styles.iframe} />
                  ) : null}
                </Box>
              </div>
            ) : (
              <div style={styles.directionColumn}>
                <Box
                  sx={{
                    width: '50%',
                    height: '50%',
                    backgroundColor: '#E5E6F0',
                  }}
                >
                  {anotherItems.map((item) =>
                    <div>
                      {item === 'Notícias' ? (
                        <div>
                          {this.state.selected_city === 'rios' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=tr%C3%AAs%20rios&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'paulo' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=paulo%20de%20frontin&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'saquarema' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=saquarema&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'queimados' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=queimados&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'nova' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=nova%20iguaçu&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'itaocara' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=itaocara&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'campos' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=campos&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : this.state.selected_city === 'rj' ? (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=rio%20de%20janeiro&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          ) : (
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={'https://news.google.com/search?q=cabo%20frio&hl=pt-BR&gl=BR&ceid=BR%3Apt-419'}
                            >
                              <Accordion
                                expanded={this.state.expanded === `panel${item}`}
                                onChange={this.handleChangePanel(`panel${item}`)}
                                style={styles.button}
                              //onClick={() => readFile()}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls={`panel${item}a-content`}
                                  id={`panel${item}a-header`}
                                >
                                  <Typography>
                                    {item}
                                  </Typography>
                                </AccordionSummary>
                              </Accordion>
                            </a>
                          )}
                        </div>
                      ) : (
                        <Accordion
                          expanded={this.state.expanded === `panel${item}`}
                          onChange={this.handleChangePanel(`panel${item}`)}
                          style={styles.button}
                        //onClick={() => readFile()}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${item}a-content`}
                            id={`panel${item}a-header`}
                          >
                            <Typography>
                              {item}
                            </Typography>
                          </AccordionSummary>

                          <AccordionDetails>

                            <div style={styles.directionRow}>
                              <TextField
                                style={{ margin: 10 }}
                                id={`keyword${item}`}
                                name={`keyword${item}`}
                                label="Buscar por palavra chave"
                                variant="outlined"
                              />

                              <Button
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 12, marginLeft: 10, height: 50, textTransform: 'none' }}
                                onClick={() => {
                                  if (this.state.selected_city === 'paulo') {
                                    this.setState({ iframeUrl: `${apiMunicipios}/readfilepaulo/${item},${document.getElementById('keyword' + item).value}` });
                                  } else {
                                    if (this.state.selected_city === 'cabo') {
                                      this.setState({ iframeUrl: `${apiMunicipios}/readfilecabo/${item},${document.getElementById('keyword' + item).value}` });
                                    } else {
                                      if (this.state.selected_city === 'saquarema') {
                                        this.setState({ iframeUrl: `${apiMunicipios}/readfilesaquarema/${item},${document.getElementById('keyword' + item).value}` });
                                      } else {
                                        if (this.state.selected_city === 'queimados') {
                                          this.setState({ iframeUrl: `${apiMunicipios}/readfilequeimados/${item},${document.getElementById('keyword' + item).value}` });
                                        } else {
                                          if (this.state.selected_city === 'nova') {
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilenova/${item},${document.getElementById('keyword' + item).value}` });
                                          } else {
                                            if (this.state.selected_city === 'itaocara') {
                                              this.setState({ iframeUrl: `${apiMunicipios}/readfileitaocara/${item},${document.getElementById('keyword' + item).value}` });
                                            } else {
                                              if (this.state.selected_city === 'campos') {
                                                this.setState({ iframeUrl: `${apiMunicipios}/readfilecampos/${item},${document.getElementById('keyword' + item).value}` });
                                              } else {
                                                if (this.state.selected_city === 'rj') {
                                                  this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item},${document.getElementById('keyword' + item).value}` });
                                                } else {
                                                  this.setState({ iframeUrl: `${apiMunicipios}/readfile/${item},${document.getElementById('keyword' + item).value}` });
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }}
                              >
                                Buscar
                              </Button>
                            </div>

                          </AccordionDetails>

                        </Accordion>
                      )}
                    </div>
                  )}
                  <TextField
                    style={{ margin: 10, width: 250 }}
                    id="pref"
                    name="pref"
                    label="Buscar por palavra chave"
                    variant="outlined"
                  />

                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: 10, textTransform: 'none', }}
                    onClick={() => {
                      if (this.state.selected_city === 'paulo') {
                        this.setState({ iframeUrl: `${apiMunicipios}/readfilepaulo/${document.getElementById('pref').value}` });
                      } else {
                        if (this.state.selected_city === 'cabo') {
                          this.setState({ iframeUrl: `${apiMunicipios}/readfilecabo/${document.getElementById('pref').value}` });
                        } else {
                          if (this.state.selected_city === 'saquarema') {
                            this.setState({ iframeUrl: `${apiMunicipios}/readfilesaquarema/${document.getElementById('pref').value}` });
                          } else {
                            if (this.state.selected_city === 'queimados') {
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilequeimados/${document.getElementById('pref').value}` });
                            } else {
                              if (this.state.selected_city === 'nova') {
                                this.setState({ iframeUrl: `${apiMunicipios}/readfilenova/${document.getElementById('pref').value}` });
                              } else {
                                if (this.state.selected_city === 'itaocara') {
                                  this.setState({ iframeUrl: `${apiMunicipios}/readfileitaocara/${document.getElementById('pref').value}` });
                                } else {
                                  if (this.state.selected_city === 'campos') {
                                    this.setState({ iframeUrl: `${apiMunicipios}/readfilecampos/${document.getElementById('pref').value}` });
                                  } else {
                                    if (this.state.selected_city === 'rj') {
                                      this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${document.getElementById('pref').value}` });
                                    } else {
                                      this.setState({ iframeUrl: `${apiMunicipios}/readfile/${document.getElementById('pref').value}` });
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }}
                  >
                    Buscar
                  </Button>
                </Box>

                <Box
                  sx={{
                    width: '94.5%',
                    height: window.innerHeight - 300,
                    backgroundColor: '#E5E6F0',
                    margin: 10,
                    marginBottom: 10,
                  }}
                >
                  {this.state.iframeUrl ? (
                    <iframe src={this.state.iframeUrl} title="Processos" style={styles.iframe} />
                  ) : null}
                </Box>
              </div>
            )}

          </Box>

          <FooterHome />

        </ThemeProvider>

      </div>

    );

  }

}

let styles = {

  button: {
    marginLeft: -2,
    borderTop: '1px solid rgba(254, 222, 90, 1)',
    borderBottom: '1px solid rgba(254, 222, 90, 1)',
    width: 360,
    //backgroundColor: '#bfcadb',
  },

  directionRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 10,
  },

  directionColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },

  iframe: {
    borderWidth: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#777777',
  },

}

export default withRouter(Search);